export const GetStartGuid = {
  "SelectFile": "Select a file",
  "Open": "Open",
  "OpenFile": "Open File",
  "Start": "Start",
  "ConvertToPDF": "Convert to PDF",
  "ConvertToPDFDescribe": "Convert from any file format to PDF or aggregate files into a PDF package",
  "CombinePDF": "Combine PDFs",
  "CombinePDFDescribe": "Quickly combine several PDF files into one",
  "AddComment": "Add Comments",
  "AddCommentDescribe": "Add comments to the document",
  "EditPDF": "Edit PDF",
  "EditPDFDescribe": "Online edit text and images in your PDF",
  "OrganizePDF": "Organize pages",
  "OrganizePDFDescribe": "Reorder, delete, insert, or rotate pages",
  "ShareComment": "Share for Comments",
  "ShareCommentDescribe": "Share a file to others for commenting or viewing",
  "StartPDFHere": "Start your PDF here",
  "StartPDFHereDescribe": "Edit PDF content and layout like with a word processor.",
  "DragDrop": "Drag and drop file here, or <span class=\"choose-file-btn online-text-btn\">Choose File</span>",
  "DragButton": "<span class=\"choose-file-btn online-text-btn\">Choose File</span>",
  "DragDes": "Drag and Drop a file here",
  "blankDes": "or start with a blank page",
  "DragDrop2": "Drag and drop file here, or <button type=\"button\" class=\"ant-btn choose-file-btn online-solid-btn\">Choose File</button>",
  "DragButton2": "<button type=\"button\" class=\"ant-btn choose-file-btn online-solid-btn\">Choose File</button>",
  "ChooseFile": "Choose File",
  "NewFeature": "New",
  "UseNow": "Use Now",
  "OpenFiles": "Open File",
  "CompareFiles": "Compare Files",
  "CompareFilesDescribe": "Compare two files and highlight the differences",
  "CombineForms": "Combine Forms to a Sheet",
  "CombineFormsDescribe": "Combine forms and export data to a sheet",
  "Watermark": "Watermark Setting",
  "WatermarkDescribe": "Remove a watermark to PDF files",
  "addWaterMark": "Add Watermark",
  "removeWaterMark": "Remove Watermark",
  "Background": "Background Setting",
  "BackgroundDescribe": "Remove a background to PDF files",
  "addBackground": "Add Background",
  "removeBackground": "Remove Background",
  "HeadersFooters": "Headers & Footers Setting",
  "HeadersFootersDescribe": "Remove Header and Footer to PDF files",
  "addHeadersFooters": "Add Headers & Footers",
  "removeHeadersFooters": "Remove Headers & Footers",
  "BatesNumbering": "Bates Numbering Setting",
  "BatesNumberingDescribe": "Remove unique serial numbers to all pages of one or more files",
  "addBatesNumbering": "Add Bates Numbering",
  "removeBatesNumbering": "Remove Bates Numbering",
  "Discover": "Discover",
  "Tools": "Tools",
  "Install": "Install app",
  "GetTheAddIn": "Get the add-in",
  "AlreadyInstalled": "Already installed",
  "Download": "Download",
  "Completed": "Completed",
  "ComingSoon": "Coming soon!",
  "AccessQuicklyPDF": "Access Foxit PDF Editor Cloud more quickly",
  "AccessQuicklyPDFDescribe": "Add Foxit PDF Editor Cloud to your desktop for an App-like experience.",
  "PdfOnDesktop": "Use PDF Editor on your desktop",
  "PdfOnDesktopDescribe": "Work on your desktop with Foxit PDF Software.",
  "PdfInMicrosoft": "Work with PDFs in Microsoft 365",
  "PdfInMicrosoftDescribe": "Use Microsoft 365 add-in to convert office files to PDF.",
  "CollaborateMicrosoftTeams": " Collaborate on a PDF in Microsoft Teams",
  "CollaborateMicrosoftTeamsDescribe": "Use Microsoft Teams App to collaborate on a PDF.",
  "SharePointAddIn": "Work with PDFs in SharePoint Online & OneDrive",
  "SharePointAddInDescribe": "Work with Foxit PDF Editor Integration in SharePoint Online & OneDrive",
  "GoogleDrive": "Work with PDFs in Google Drive",
  "GoogleDriveDescribe": "PDF files can be viewed, annotated, and edited right from Google Drive.",
  "NextPage": "Next Page",
  "PrevPage": "Previous Page",
  'aiForbidden':"Sorry, AI Assistant is not available in your region.",
  "aiAssistant":"AI Assistant",
  "aiHint":"Use AI Assistant to increase productivity.",
  "now":"Use Now"
}